import { render, staticRenderFns } from "./EEscolhaMes.vue?vue&type=template&id=226401ce"
import script from "./EEscolhaMes.vue?vue&type=script&lang=js"
export * from "./EEscolhaMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports